
import {
  IconCalendar,
  IconCreditCard,
  IconExports,
  IconHeart,
  IconTools,
  RevModal,
  RevSpinner,
} from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import { productWarrantyServices } from '@http/endpoints'
import warrantyTranslations from '@reassurance/components/WarrantyModal/WarrantyModal.translations'

import ContentRow from '../../ContentRow'

import translations from './PerksModal.translations'

const ICONS = {
  warranty: IconTools,
  return: IconCalendar,
  shipping: IconExports,
  customerCare: IconHeart,
  instalmentPayment: IconCreditCard,
}

export default {
  components: {
    ContentRow,
    RevModal,
    RevSpinner,
  },
  props: {
    listingId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      warranty: {},
      isLoading: true,
      shouldDisplayError: false,
      cachedListingId: null,
    }
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.PERKS,

    translations: () => translations,
    warrantyTranslations: () => warrantyTranslations,

    ...mapGetters({
      country: 'config/country',
    }),

    productId() {
      return this.$route.params.uuid
    },

    isCachedListing() {
      return this.listingId === this.cachedListingId
    },

    isWarrantyEmpty() {
      return isEmpty(this.warranty)
    },

    services() {
      return (
        this.shouldShowServices &&
        this.warranty.includedServices.map(
          ({ type, title, texts, hyperlink }) => {
            return {
              icon: ICONS[type],
              title,
              texts,
              hyperlink,
            }
          },
        )
      )
    },

    shouldShowServices() {
      return (
        !isEmpty(this.warranty.includedServices) &&
        !this.isLoading &&
        !this.shouldDisplayError
      )
    },
  },
  methods: {
    async fetchWarrantyServices() {
      if (this.isCachedListing && !this.isWarrantyEmpty) {
        this.isLoading = false

        return
      }

      try {
        const { payload } = await this.$store.dispatch('http/request', {
          request: productWarrantyServices,
          pathParams: {
            id: this.productId,
            listingId: this.listingId,
          },
        })
        this.warranty = payload
        this.cachedListingId = this.listingId
        this.isLoading = false
      } catch {
        this.isLoading = false
        this.displayError = true
      }
    },
    resetLoading() {
      this.isLoading = true
    },
  },
}
